import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconAssistantAvatar = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      viewBox="0 0 85 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block w-full h-full fill-current"
    >
      <path
        d="M42.868 45.192a22.6 22.6 0 0012.519-3.782 22.444 22.444 0 008.296-10.068 22.325 22.325 0 001.275-12.96 22.389 22.389 0 00-6.175-11.48A22.56 22.56 0 0047.239.776a22.623 22.623 0 00-13.017 1.292A22.503 22.503 0 0024.12 10.34a22.347 22.347 0 00-3.778 12.467c0 2.943.583 5.856 1.716 8.575a22.376 22.376 0 004.884 7.266 22.494 22.494 0 007.309 4.85 22.578 22.578 0 008.617 1.693zM.362 102.843h20.91l21.327-37.511-13.737-16.378c-27.664 0-28.5 35.306-28.5 53.889zM84.803 102.843h-59.64l30.643-53.889c28.309 0 28.997 36.236 28.997 53.889z"
        fill="#4894EE"
      />
      <path fill="#F7FAFC" d="M54.221 76.427h14.793v3.17H54.221z" />
    </svg>,
  );
IconAssistantAvatar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconAssistantAvatar;
